var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gamehistory"},[_c('v-container',{staticClass:"pt-0"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('gameHistory.title')))]),_c('game-list',{attrs:{"games":this.games,"loading":_vm.loading}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }